import { gql } from 'apollo-angular';

export const CloneFunnelDocument = gql`
  mutation cloneFunnel($funnelId: Int!) {
    cloneFunnel(funnelId: $funnelId) {
      id
    }
  }
`;
